module.exports = __webpack_public_path__ + "img/intercomscene3.b19a8d85.png";